import { Context, Effect, Layer } from "effect";

export type KeydownListener = (event: KeyboardEvent) => void;
export class KeyboardEventsIo extends Context.Service<KeyboardEventsIo, {
  readonly add: (listener: KeydownListener) => Effect.Effect<void>;
  readonly remove: (listener: KeydownListener) => Effect.Effect<void>;
}>()("workerstation/frontend/KeyboardEventsIo") {}

export const KeyboardEventsIoLive = Layer.succeed(KeyboardEventsIo, {
  add: listener => Effect.sync(() => window.addEventListener("keydown", listener)),
  remove: listener => Effect.sync(() => window.removeEventListener("keydown", listener))
});
export const KeyboardEventsIoTest = (io: Context.Service.Shape<typeof KeyboardEventsIo>) =>
  Layer.succeed(KeyboardEventsIo, io);
